import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from '../ui/SectionHeading';
import { Baby, MessageSquareWarning, ArrowLeftRight, MicOff, HelpCircle, Users, Lock, ShieldOff } from 'lucide-react';
const pains = [{
  title: 'Todo el mundo habla del bebé',
  desc: 'Citas, compras, nombres — y de ustedes dos, nadie pregunta nada.',
  icon: Baby
}, {
  title: "Discuten por cosas que 'no tienen nada que ver'",
  desc: 'Un plato sin lavar tapa un miedo que ninguno dijo en voz alta.',
  icon: MessageSquareWarning
}, {
  title: 'Viven el mismo embarazo de formas opuestas',
  desc: 'Ella necesita hablar todo el tiempo. Él no sabe qué lugar ocupa.',
  icon: ArrowLeftRight
}, {
  title: 'El silencio se lee como desinterés',
  desc: "Él se calla 'para no preocuparla' y ella lo interpreta como que no le importa.",
  icon: MicOff
}, {
  title: "Sienten que 'algo cambió' entre ustedes",
  desc: 'Pero no logran nombrar qué, ni cuándo empezó.',
  icon: HelpCircle
}, {
  title: 'La familia y los amigos se meten',
  desc: 'Opiniones y expectativas externas que terminan pesando más que lo que ustedes necesitan.',
  icon: Users
}, {
  title: 'Cada uno carga sus miedos en soledad',
  desc: 'Aunque estén en pareja, sienten que atraviesan esto cada uno por su lado.',
  icon: Lock
}, {
  title: 'Llega el tercer trimestre y no se sienten más equipo',
  desc: 'Sino más cansados, más distantes, más a la defensiva.',
  icon: ShieldOff
}];
export function PainPoints() {
  return <section className="py-12 md:py-24 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-198">
      <SectionHeading title="¿TE PASA ESTO?" subtitle="Si están esperando su primer hijo, esto les va a resultar familiar:" data-id="element-199" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 mb-10 md:mb-16" data-id="element-200">
        {pains.map((pain, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} whileTap={{
        scale: 0.98
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.05
      }} className="bg-offwhite p-4 md:p-6 rounded-2xl border border-brown/5 flex flex-col cursor-pointer hover:border-terracotta/30 transition-colors" data-id="element-201">
            <pain.icon className="text-terracotta/60 mb-3" size={24} data-id="element-202" />
            <h3 className="font-serif font-bold text-brown text-sm md:text-base mb-2 md:mb-3 leading-tight" data-id="element-203">
              {pain.title}
            </h3>
            <p className="font-sans text-xs md:text-sm text-brown/70 leading-relaxed mt-auto" data-id="element-204">
              {pain.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="text-center bg-terracotta/10 p-6 md:p-8 rounded-2xl max-w-3xl mx-auto" data-id="element-205">
        <p className="font-serif text-xl md:text-3xl font-bold text-terracotta" data-id="element-206">
          ¿Cuántos meses más van a vivir este embarazo en paralelo, en lugar de
          en equipo?
        </p>
      </motion.div>
    </section>;
}